import { Application, Company, Contact, ContactRole } from "./models/data-model";

export class RegistrationHelper {

    static cloneApplication(application: Application): Application {
        return {
            ...application,
            company: RegistrationHelper.cloneCompany(application.company),
            applicant: {
                ...application.applicant
            }
        };
    }

    static cloneCompany(company: Company): Company {
        let cloned = {
            ...company,
            registeredAddress: {
                ...company.registeredAddress
            }
        };
        if (company.tradingAddress) {
            cloned.tradingAddress = {
                ...company.tradingAddress
            };
        }
        return cloned;
    }

    static cloneContact(contact: Contact, roles: ContactRole[]): Contact {
        return {
            ...contact,
            roles: roles
        };
    }

    static mergeContacts(original: Contact, updated: Contact, roles: ContactRole[]): Contact {
        return {
            ...original,
            ...updated,
            address: {
                ...original.address,
                ...updated.address
            },
            roles: roles
        };
    }

}
